const EC_CONFIG = Object.freeze({
    serverName: "EldenCraft",
    serverIp: ""
});

let initialized = false;

function makeElement(tag, className, text) {
    const el = document.createElement(tag);

    if (className) {
        el.className = className;
    }

    if (text !== undefined && text !== null) {
        el.textContent = text;
    }

    return el;
}

function plainText(value) {
    const div = document.createElement("div");
    div.innerHTML = value || "";
    return (div.textContent || div.innerText || "").trim();
}

function showToast(message) {
    let toast = document.getElementById("ec-toast");

    if (!toast) {
        toast = makeElement("div", "ec-toast");
        toast.id = "ec-toast";
        document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.classList.add("show");

    clearTimeout(toast.__timer);

    toast.__timer = setTimeout(() => {
        toast.classList.remove("show");
    }, 2200);
}

function prettifyWorldName(raw) {
    const key = String(raw || "").toLowerCase();

    const map = {
        "minecraft:overworld": "Sobrevivencia",
        "minecraft:the_nether": "Nether",
        "minecraft:the_end": "The End",
        "minecraft:rpgmap": "RPG Map",
        "minecraft:rpg": "RPG",
        "minecraft:conquista": "Conquista",
        "minecraft:minimart_world": "MiniMart",
        "minecraft:turf_wars": "Turf Wars",
        "minecraft:spawn": "Spawn"
    };

    if (map[key]) {
        return map[key];
    }

    if (key.startsWith("minecraft:")) {
        return key.substring("minecraft:".length).replaceAll("_", " ");
    }

    return raw || "Mundo";
}

function createWorldChip() {
    const chip = makeElement("div", "ec-world-chip", "Carregando mapa...");
    chip.id = "ec-world-chip";
    document.body.appendChild(chip);
    return chip;
}

function createSearch(S, sidebar, playerFieldset) {
    const fieldset = document.createElement("fieldset");
    fieldset.id = "ec-search";

    const legend = document.createElement("legend");
    legend.textContent = "BUSCAR";

    const wrap = makeElement("div", "ec-search-wrap");

    const input = document.createElement("input");
    input.type = "text";
    input.id = "ec-search-input";
    input.placeholder = "Jogador ou X, Z...";
    input.autocomplete = "off";

    const button = makeElement("button", "ec-search-button", "BUSCAR");
    button.type = "button";

    wrap.appendChild(input);
    wrap.appendChild(button);

    fieldset.appendChild(legend);
    fieldset.appendChild(wrap);

    sidebar.insertBefore(fieldset, playerFieldset);

    const search = () => {
        const value = input.value.trim();

        if (!value) {
            return;
        }

        const coordinates = value.match(/^(-?\d+)\s*[,;\s]\s*(-?\d+)$/);

        if (coordinates) {
            const x = Number(coordinates[1]);
            const z = Number(coordinates[2]);

            S.playerList.followPlayerMarker(null);
            S.centerOn(x, z, Math.max(S.map.getZoom(), 1));

            showToast(`Coordenadas: ${x}, ${z}`);
            return;
        }

        const query = value.toLowerCase();
        let result = null;

        for (const [uuid, player] of S.playerList.players) {
            const name = plainText(player.displayName || player.name || "").toLowerCase();

            if (name === query || name.includes(query)) {
                result = { uuid, player };
                break;
            }
        }

        if (!result) {
            input.classList.remove("ec-search-error");
            void input.offsetWidth;
            input.classList.add("ec-search-error");
            showToast("Jogador nao encontrado.");
            return;
        }

        if (S.playerList.showPlayer(result.uuid)) {
            S.playerList.followPlayerMarker(result.uuid);
            showToast(`Localizando ${plainText(result.player.displayName || result.player.name || "jogador")}`);
        }
    };

    button.addEventListener("click", search);

    input.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
            search();
        }
    });

    return fieldset;
}

function createLayers(S, sidebar, playerFieldset) {
    const fieldset = document.createElement("fieldset");
    fieldset.id = "ec-layers";

    const legend = document.createElement("legend");
    legend.textContent = "CAMADAS DO MAPA";

    const container = makeElement("div", "ec-layers-container");

    fieldset.appendChild(legend);
    fieldset.appendChild(container);

    sidebar.insertBefore(fieldset, playerFieldset);

    const mount = () => {
        if (!S.layerControl || !S.layerControl.controls || !S.layerControl.controls.getContainer) {
            return false;
        }

        const control = S.layerControl.controls.getContainer();

        if (!control) {
            return false;
        }

        if (control.parentElement !== container) {
            control.classList.add("ec-layer-control", "leaflet-control-layers-expanded");
            container.appendChild(control);
        }

        return true;
    };

    if (!mount()) {
        const timer = setInterval(() => {
            if (mount()) {
                clearInterval(timer);
            }
        }, 300);
    }

    return fieldset;
}

function updateWorlds(S) {
    if (!S.worldList || !S.worldList.curWorld) {
        return;
    }

    const current = S.worldList.curWorld;

    for (const link of S.sidebar.worlds.element.querySelectorAll("a")) {
        link.classList.toggle("ec-world-current", link.id === current.name);

        const img = link.querySelector("img");
        const currentText = plainText(link.textContent);

        if (currentText) {
            const pretty = prettifyWorldName(currentText);
            link.innerHTML = "";
            if (img) {
                link.appendChild(img);
            }
            const span = document.createElement("span");
            span.textContent = pretty;
            link.appendChild(span);
        }
    }
}

function updatePlayers(S) {
    if (!S.playerList || !S.playerList.players) {
        return;
    }

    for (const [uuid, player] of S.playerList.players) {
        const row = document.getElementById(uuid);

        if (!row) {
            continue;
        }

        let meta = row.querySelector(".ec-player-meta");

        if (!meta) {
            meta = makeElement("small", "ec-player-meta");
            row.appendChild(meta);
        }

        let locate = row.querySelector(".ec-player-locate");

        if (!locate) {
            locate = makeElement("span", "ec-player-locate", "");
            row.appendChild(locate);
        }

        const world = S.worldList.worlds.get(player.world);
        const rawWorldName = world ? (world.display_name || world.name) : player.world;
        const worldName = prettifyWorldName(rawWorldName);

        meta.textContent = `${worldName} - ${Math.round(player.x)}, ${Math.round(player.z)}`;
    }
}

function updateStatus(S, worldChip) {
    if (!S.playerList || !S.worldList || !S.worldList.curWorld) {
        return;
    }

    const total = S.playerList.players.size;
    const currentWorld = S.worldList.curWorld;

    let current = 0;

    for (const player of S.playerList.players.values()) {
        if (player.world === currentWorld.name) {
            current++;
        }
    }

    const currentName = prettifyWorldName(currentWorld.display_name || currentWorld.name);
    worldChip.textContent = `${currentName.toUpperCase()} - ${current} ONLINE`;

    const playersLegend = S.sidebar.players.legend;
    if (playersLegend) {
        playersLegend.textContent = `JOGADORES (${total})`;
    }
}

async function copyCoordinates(x, z) {
    const text = `${x}, ${z}`;

    try {
        await navigator.clipboard.writeText(text);
        showToast(`Coordenadas copiadas: ${text}`);
    } catch {
        showToast(text);
    }
}

export function initEldenCraftUI(S) {
    if (initialized) {
        return;
    }

    initialized = true;

    document.body.classList.add("eldencraft-ui");

    const worldChip = createWorldChip();

    const sidebar = S.sidebar.sidebar;
    const worlds = S.sidebar.worlds;
    const players = S.sidebar.players;

    if (S.sidebar.pin) {
        S.sidebar.pin.pinned = true;

        if (S.sidebar.pin.element) {
            S.sidebar.pin.element.style.display = "none";
        }
    }

    S.sidebar.showSidebar = true;
    S.sidebar.show(true);
    sidebar.style.display = "";

    if (worlds && worlds.legend) {
        worlds.legend.textContent = "MUNDOS";
    }

    if (players && players.legend) {
        players.legend.textContent = "JOGADORES";
    }

    createSearch(S, sidebar, players.element);
    createLayers(S, sidebar, players.element);

    const update = () => {
        updateWorlds(S);
        updatePlayers(S);
        updateStatus(S, worldChip);
    };

    update();

    const timer = setInterval(update, 1000);

    window.addEventListener("beforeunload", () => clearInterval(timer), { once: true });

    // clicar no mapa copia a coordenada
    S.map.on("click", async (event) => {
        const x = Math.round(event.latlng.lng);
        const z = Math.round(event.latlng.lat);
        await copyCoordinates(x, z);
    });

    setTimeout(() => {
        S.map.invalidateSize();
    }, 100);
}